<mat-card class="style-legend-panel mat-elevation-z4" *ngIf="state() as s" cdkDrag>
  <button mat-icon-button class="legend-close-button" (click)="close()" aria-label="Close legend">
    <mat-icon>close</mat-icon>
  </button>

  <mat-card-header>
    <div class="d-flex align-items-center gap-2 w-100 pe-4 min-w-0" cdkDragHandle>
      <mat-icon class="legend-drag-icon">drag_indicator</mat-icon>
      <mat-card-title class="legend-title" [matTooltip]="s.layerName" matTooltipShowDelay="400">Legend — {{ s.layerName }}</mat-card-title>
    </div>
  </mat-card-header>

  <mat-card-content>
    <p class="legend-subtitle mb-2" *ngIf="s.metadata?.property_used">{{ s.metadata?.property_used }}</p>

    <div class="mb-1" *ngFor="let row of rows()">
      <div
        class="legend-row d-flex align-items-center gap-2"
        [class.legend-row--hidden]="!row.isVisible"
        role="button"
        tabindex="0"
        [attr.aria-pressed]="row.isVisible"
        [matTooltip]="row.isVisible ? 'Hide these features' : 'Show these features'"
        matTooltipShowDelay="500"
        (click)="toggleRow(row.id)"
        (keydown.enter)="toggleRow(row.id)"
        (keydown.space)="toggleRow(row.id); $event.preventDefault()"
      >
        @if (row.iconKey) {
          <mat-icon [svgIcon]="row.iconKey" class="legend-icon"></mat-icon>
        } @else {
          <span
            class="legend-swatch"
            [style.background]="row.fillColor"
            [style.border-color]="row.strokeColor"
            [style.border-width.px]="row.strokeWidth"
          ></span>
        }
        <span class="legend-label">{{ row.label }}</span>
      </div>
      @if (row.labelProperty) {
        <span class="legend-label-hint mat-body-small text-muted ms-4">Label: {{ row.labelProperty }}</span>
      }
    </div>

    <p class="legend-description mt-2 mb-0" *ngIf="s.metadata?.description">{{ s.metadata?.description }}</p>
  </mat-card-content>
</mat-card>
